/* Signed out: the one filled control in the bar, because it is the one thing a reader can do. */
.signIn {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 12px;
  font: inherit;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--on-fill);
  text-decoration: none;
  background: var(--accent);
  border: 1px solid var(--accent);
  border-radius: var(--radius-ctl);
  cursor: pointer;
  transition: background-color var(--dur-1) var(--ease-std);
}

.signIn:hover {
  background: var(--accent-h);
  border-color: var(--accent-h);
}

.signIn:active {
  background: var(--ink);
  border-color: var(--ink);
}
